/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React from 'react';
import cx from 'classnames';

import { LogoMakeType } from './LogoMake.helpers';

import styles from './LogoMake.module.scss';

type LogoMakeProps = {
  className?: string;
  element?: React.ElementType;
  make: LogoMakeType | '';
  small?: boolean;
  title?: string;
  to?: string;
  webp?: boolean;
}

export const LogoMake = ({
  className,
  element: Element = 'div',
  make,
  small = false,
  title,
  to,
  webp = false,
  ...p
}: LogoMakeProps) => {
  const classNames = cx(
    className,
    styles.logoMake,
    { [styles.small]: small },
  );

  const logoMakeExtension = webp ? `webp/${make}.webp` : `${make}.png`;

  const logoMakeUrl = make?.trim() ? logoMakeExtension : null;

  const inlineStyles = {
    '--logo-make-bg': logoMakeUrl ? `url(/makesLogos/${logoMakeUrl})` : 'none',
  } as React.CSSProperties;

  return (
    <Element className={classNames} style={inlineStyles} {...p} {...{ title, to }} />
  );
};
